<template>
  <div class="row px-4">
    <div class="col-12">
      <p class="text-center" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="200">
        <i class="fal fa-info-circle fa-2x mb-2"></i><br /><span v-html="$t('checkr.msg')"></span>
      </p>
      <div class="col-md-12 col-sm-12 mb-4" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
        <div class="text-center">
          <button v-show="!readonly" @click="startBackgroundCheck" class="btn btn-secondary btn-default btn-gray"><i class="fal fa-square fa-1x"></i> {{ $t('verification.start') }}</button>
          <button v-show="readonly" class="btn btn-success btn-default"><i class="fal fa-check-square fa-1x"></i>{{ $t('verification.completed') }}</button>
        </div>
      </div>
    </div>
    <more-info />
  </div>
</template>
<script>
import '@/shared/validations.js'
import Vue from 'vue'
import MoreInfo from './more_info.vue'
import BackButton from './back_button.vue'

export default {
  components: {
    MoreInfo, BackButton
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {

  },
  methods: {
    startBackgroundCheck() {
      this.$emit('update', { checkrVerification: true  })
    }
  }
}
</script>
